import { DEBUG_UNLOCK_KEY } from './channel';

/**
 * Déblocage du mode debug par **code** (v0.55.3, A115). Les Notes de dev ne
 * montrent plus que les patch notes, les crédits et l'onglet Debug ; sur un
 * appareil de joueur (production, sans `?debug`), l'onglet Debug demande un
 * code. Le code n'est pas dans le bundle : seule son empreinte SHA-256 l'est
 * (`DEBUG_CODE_HASH`). Une fois accepté, la préférence `DEBUG_UNLOCK_KEY` est
 * posée et la page rechargée (les outils de debug du démarrage, `window.__dod`,
 * ne s'installent qu'au chargement).
 *
 * Changer le code : `node -e "console.log(require('crypto').createHash('sha256').update('LE-CODE').digest('hex'))"`
 * et remplacer la constante. Le code est normalisé avant la comparaison :
 * espaces retirés aux extrémités, majuscules.
 */
export const DEBUG_CODE_HASH = '57403415c2106ce0a712c1f78d5813fb011d6984f939570874cb892949dcf06c';

export function normalizeDebugCode(raw: string): string {
  return raw.trim().toUpperCase();
}

async function sha256Hex(text: string): Promise<string> {
  const c = (globalThis as { crypto?: Crypto }).crypto;
  if (!c?.subtle) return '';
  const buf = await c.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf), (b) => b.toString(16).padStart(2, '0')).join('');
}

/** Le code saisi est-il le bon ? (`expected` : empreinte à comparer, pour les tests.) */
export async function verifyDebugCode(raw: string, expected: string = DEBUG_CODE_HASH): Promise<boolean> {
  const code = normalizeDebugCode(raw);
  if (!code) return false;
  return (await sha256Hex(code)) === expected;
}

export function unlockDebug(): void {
  try {
    localStorage.setItem(DEBUG_UNLOCK_KEY, '1');
  } catch {
    /* stockage indisponible : le mode debug ne survit pas à la session */
  }
}

export function lockDebug(): void {
  try {
    localStorage.removeItem(DEBUG_UNLOCK_KEY);
  } catch {
    /* rien */
  }
}
